export default {"src":"/_next/static/media/set-spotswap-pay-mode-guide-zh.b4f31d66.gif","height":150,"width":600,"blurWidth":0,"blurHeight":0};